import {http} from "@/api/http";
import {API_URL} from "@/api/base";


export async function getTasks(params) {
    const queryString = Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return await http.get(
        `${API_URL}/v1/tasks/status?${queryString}`
    )
}